import React, { FC, ReactElement } from 'react';
import { TextStyle } from 'react-native';
import { Typography, IStyleProp, defaultStyle, LabelType } from '@fkhplus/common/src/components/atoms/Text/style';

export interface ILabelStyle extends IStyleProp {
    type?: LabelType;
}

export interface ILabelProps {
    textStyle?: ILabelStyle;
    style?: TextStyle;
}

export const Label: FC<ILabelProps> = (props): ReactElement => {
    const defaultType = 'labelLarge'
    const { children, textStyle = { ...defaultStyle, type: defaultType }, style } = props;
    const styleProp: IStyleProp = {
        fontWeight: textStyle.fontWeight,
        fontType: textStyle.fontType,
        color: textStyle.color,
    }

    return (
        <Typography style={style} type={textStyle.type || defaultType } styleProp={styleProp} allowFontScaling={false}>
            {children}
        </Typography>
    );
};
